module.exports = __webpack_public_path__ + "img/Angiogenesis-BRCA_10X_WTA.548b3840.png";